// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner___3v_dE"};